
















import { Component, Prop, Watch, Vue } from 'vue-property-decorator';
import VueEasymde from 'vue-easymde';
import MediaSelectorDialog from '@/components/KnowledgeBase/MediaSelectorDialog.vue';

@Component({
  name: 'MarkdownEditor',
  components: {
    VueEasymde,
    MediaSelectorDialog
  }
})
export default class MarkdownEditor extends Vue {
  @Prop({ required: true })
  public value!: string;

  @Prop({ default: 300 })
  public minHeight!: number;

  public content = '';
  public mediaSelectorDialog = false;

  public get editorConfig() {
    return {
      spellChecker: false,
      minHeight: `${this.minHeight}px`,
      toolbar: [
        'bold',
        'italic',
        'heading',
        '|',
        'quote',
        'unordered-list',
        'ordered-list',
        '|',
        'link',
        {
          name: 'image',
          action: () => {
            this.openMediaSelector();
          },
          className: 'fa fa-picture-o',
          title: 'Insert Image from Media Library'
        },
        '|',
        'code',
        'table',
        '|',
        'preview',
        'side-by-side',
        'fullscreen',
        '|',
        'guide'
      ],
      status: ['lines', 'words', 'cursor'],
      placeholder: 'Write your content in markdown...',
      autosave: {
        enabled: false
      }
    };
  }

  @Watch('value', { immediate: true })
  onValueChange(newVal: string) {
    if (newVal !== this.content) {
      this.content = newVal;
    }
  }

  @Watch('content')
  onContentChange(newVal: string, oldVal: string) {
    // Only emit if content changed and it's different from the value prop
    // This means the change came from user input, not from prop update
    if (newVal !== this.value) {
      this.$emit('input', newVal);
    }
  }

  handleInput(value: string) {
    // This handles the @input event from vue-easymde
    this.$emit('input', value);
  }

  openMediaSelector() {
    this.mediaSelectorDialog = true;
  }

  onMediaSelected(media: any) {
    // Determine the markdown syntax based on media type
    let markdownSyntax = '';

    if (media.mediaType === 1) {
      // Image type - use standard markdown image syntax
      markdownSyntax = `![${media.altText}](${media.mediaUrl} "${media.fileName}")`;
    } else if (media.mediaType === 2) {
      // Video type - use HTML5 video tag
      markdownSyntax = `<video controls width="640">\n  <source src="${media.mediaUrl}" type="video/mp4">\n  Your browser does not support the video tag.\n</video>`;
    } else {
      // File type - use link syntax
      markdownSyntax = `[${media.fileName}](${media.mediaUrl})`;
    }

    // Try to get the EasyMDE instance and insert at cursor position
    const refComponent = this.$refs.easymde as any;
    let inserted = false;

    // Try different ways to access the EasyMDE instance
    const easymde = refComponent?.simplemde || refComponent?.$refs?.simplemde || refComponent?.easymde;

    if (easymde && easymde.codemirror) {
      try {
        const cm = easymde.codemirror;
        const cursor = cm.getCursor();
        cm.replaceRange(markdownSyntax, cursor);
        this.content = easymde.value();
        cm.focus();
        inserted = true;
      } catch (error) {
        console.warn('Failed to insert at cursor position:', error);
      }
    }

    // Fallback: append to the end of content if we couldn't insert at cursor
    if (!inserted) {
      if (this.content && !this.content.endsWith('\n')) {
        this.content += '\n\n';
      } else if (!this.content) {
        this.content = '';
      } else {
        this.content += '\n';
      }
      this.content += markdownSyntax;
    }

    this.$emit('input', this.content);
  }
}
